import EditActivityForm from '../../forms/edit-activity-form';
import Button from '../../UI/button';
import ModalCustom from '../../UI/modal';
import { useTrip } from '../../contexts/trip-context';

type Props = {
  show: boolean;
  handleClose: () => void;
  activityId?: string;
  tripId?: string;
};
const EditActivityModal = ({
  show,
  handleClose,
  activityId: propActivityId,
  tripId: propTripId
}: Props) => {
  const { trip } = useTrip();

  // Prefer explicit IDs from modal state; only fallback tripId to context.
  const tripId = propTripId || trip?.id || '';
  const activityId = propActivityId || '';
  const destinationId =
    trip?.activities?.find((activity) => activity.id === activityId)
      ?.destinationId ||
    trip?.activityDestinationMap?.[activityId] ||
    undefined;

  if (!tripId || !activityId) {
    return (
      <ModalCustom
        show={show}
        onHide={handleClose}
        title='Edit The Activity'
        headerClassName='edit-activity-modal-header'
      >
        <p>No activity selected for editing.</p>
        <div className='d-flex justify-content-center mt-3'>
          <Button
            variant='secondary'
            onClick={handleClose}
            width={140}
          >
            Close
          </Button>
        </div>
      </ModalCustom>
    );
  }

  return (
    <ModalCustom
      show={show}
      onHide={handleClose}
      title='Edit The Activity'
      headerClassName='edit-activity-modal-header'
    >
      <EditActivityForm
        activityId={activityId}
        tripId={tripId}
        destinationId={destinationId}
        onSuccess={handleClose}
      />
      <div className='d-flex justify-content-center mt-3'>
        <Button
          variant='secondary'
          onClick={handleClose}
          width={140}
        >
          Close
        </Button>
      </div>
    </ModalCustom>
  );
};
export default EditActivityModal;
